module.exports = __webpack_public_path__ + "static/media/exemplo_pessoas.bfd302ba.csv";